export enum ToolbarSize {
	XXL = 6,
	XL = 5,
	L = 4,
	M = 3,
	S = 2,
	XXXS = 1,
}
